module.exports = __webpack_public_path__ + "static/segment-image@3x-b94a580acd191e06218ac2013814f6bb.png";